export default __webpack_public_path__ + "static/media/jrc_logo_flat.ed0426cd.ai";